interface DraftPreviewProps {
  html: string;
}

export function DraftPreview({ html }: DraftPreviewProps) {
  return (
    <div className="surface p-1 overflow-hidden">
      <div className="flex items-center gap-1.5 px-3 py-1.5 border-b border-border">
        <span className="w-2.5 h-2.5 rounded-full bg-danger/60" />
        <span className="w-2.5 h-2.5 rounded-full bg-warn/60" />
        <span className="w-2.5 h-2.5 rounded-full bg-success/60" />
        <span className="ml-2 path-chip">draft preview</span>
      </div>
      <iframe
        title="Draft preview"
        srcDoc={html}
        sandbox=""
        className="w-full h-[70vh] rounded-md bg-white"
      />
    </div>
  );
}
